// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 添加 POST operationapi/api/user/create */
export async function postUserCreate(body: API.AddUserParm, options?: { [key: string]: any }) {
  return request<API.BooleanResult>('operationapi/api/user/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前用户信息 POST operationapi/api/user/current */
export async function postUserCurrent(options?: { [key: string]: any }) {
  return request<API.OperationerUserVoResult>('operationapi/api/user/current', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 处理没有头像和没有昵称的用户 GET operationapi/api/user/dealNodata */
export async function getUserDealNodata(options?: { [key: string]: any }) {
  return request<any>('operationapi/api/user/dealNodata', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 删除 POST operationapi/api/user/delete/${param0} */
export async function postUserOpenApiDeleteId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postUser_openAPI_deleteIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.BooleanResult>(`operationapi/api/user/delete/${param0}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量禁用 POST operationapi/api/user/disable */
export async function postUserDisable(body: number[], options?: { [key: string]: any }) {
  return request<API.BooleanResult>('operationapi/api/user/disable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改自己密码 POST operationapi/api/user/edit/my/pwd */
export async function postUserEditMyPwd(body: API.EditMyPwdParm, options?: { [key: string]: any }) {
  return request<API.BooleanResult>('operationapi/api/user/edit/my/pwd', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改用户密码 POST operationapi/api/user/edit/pwd */
export async function postUserEditPwd(body: API.EditUserPwdParm, options?: { [key: string]: any }) {
  return request<API.BooleanResult>('operationapi/api/user/edit/pwd', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改用户角色 POST operationapi/api/user/edit/role */
export async function postUserEditRole(
  body: API.EditUserRoleParm,
  options?: { [key: string]: any },
) {
  return request<API.BooleanResult>('operationapi/api/user/edit/role', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量启用 POST operationapi/api/user/enable */
export async function postUserEnable(body: number[], options?: { [key: string]: any }) {
  return request<API.BooleanResult>('operationapi/api/user/enable', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 通过Id获取详情 GET operationapi/api/user/get/${param0} */
export async function getUserGetId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserGetIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.UserVoResult>(`operationapi/api/user/get/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 获取所有列表 GET operationapi/api/user/get/all */
export async function getUserGetAll(options?: { [key: string]: any }) {
  return request<API.UserVoIEnumerableResult>('operationapi/api/user/get/all', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取默认头像 GET operationapi/api/user/get/DefaultAvatar */
export async function getUserGetDefaultAvatar(options?: { [key: string]: any }) {
  return request<any>('operationapi/api/user/get/DefaultAvatar', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取分页列表 POST operationapi/api/user/get/pagelist */
export async function postUserGetPagelist(
  body: API.SearchUserParm,
  options?: { [key: string]: any },
) {
  return request<API.UserVoPageResult>('operationapi/api/user/get/pagelist', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户-角色 GET operationapi/api/user/get/user/role/${param0} */
export async function getUserGetUserRoleUid(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserGetUserRoleUidParams,
  options?: { [key: string]: any },
) {
  const { uid: param0, ...queryParams } = params;
  return request<API.Int64IEnumerableResult>(`operationapi/api/user/get/user/role/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 保存用户-角色 POST operationapi/api/user/save/user/role */
export async function postUserSaveUserRole(
  body: API.SaveOperationRoleParm,
  options?: { [key: string]: any },
) {
  return request<API.StringResult>('operationapi/api/user/save/user/role', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
